module.exports = __webpack_public_path__ + "media/images/4-7d36285e7859859a4ca276d090cbc79d.jpg";